export const model = {
  global: {
    tabClassName: "mytab",
    tabSetEnableMaximize: false,
    tabSetClassNameTabStrip: "mytabstrip",
  },
  borders: [],
  layout: {
    type: "row",
    id: "#c4f61be1-a9fd-46a5-9104-cdf174667540",
    children: [
      {
        type: "row",
        id: "#82c018a6-7454-4f2d-901f-b1153dcb61a9",
        children: [
          {
            type: "tabset",
            id: "#a6ceb3db-a5c0-40a6-9h058-acdaece22b97x",
            weight: 4.5540929200904285,
            tabStripHeight: 6,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-460h0-852a-62ad41b5881ccx",
                name: "",
                component: "Header",
                enableClose: false,
                enableFloat: false,
              },
            ],
          },
          {
            type: "tabset",
            id: "#a6ceb3db-a5c0-40a6-9058-acdaece22b97x",
            weight: 4.788141160753582,
            tabStripHeight: 6,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-4600-852a-62ad41b5881ccx",
                name: "",
                component: "Controls",
                enableClose: false,
                enableFloat: false,
              },
            ],
            active: true,
          },
          {
            type: "row",
            id: "#63689b69-c672-475c-ad0b-cd05b54d9139",
            weight: 83.16245173940433,
            children: [
              {
                type: "tabset",
                id: "#a6ceb3db-a5c0-40a6-9058-acdaece22b97z",
                weight: 11.843876177658142,
                tabStripHeight: 6,
                children: [
                  {
                    type: "tab",
                    id: "#d7203016-ec93-4600-852a-62ad41b5881ccz",
                    name: "",
                    component: "HorizonTable",
                    enableClose: false,
                    enableFloat: false,
                  },
                ],
              },
              {
                type: "tabset",
                id: "#a6ceb3db-a5c0-40a6-9058-acdaece22b97",
                weight: 88.15612382234185,
                tabStripHeight: 6,
                children: [
                  {
                    type: "tab",
                    id: "#d7203016-ec93-4600-852a-62ad41b5881cc",
                    name: "",
                    component: "HorizonSpider",
                    enableClose: false,
                    enableFloat: false,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};
